import {Box, Alert, AlertTitle, Button, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';
import {useState} from 'react';

/**
 * Error box component.
 */
export const ErrorBox = (props: {error: string}) => {
  // Hold state
  const [showDetails, setShowDetails] = useState<boolean>(false);

  // Translations
  const {t} = useTranslation();

  // Default result
  return (
    <>
      <Alert severity="error">
        <AlertTitle>{t(translations.error_box.title)}</AlertTitle>
        <Typography variant="body2">{t(translations.error_box.description)}</Typography>
        <Button
          sx={{marginTop: '8px', marginLeft: '-8px'}}
          variant="text"
          onClick={() => {
            setShowDetails(!showDetails);
          }}
        >
          {t(translations.error_box.details_button)}
        </Button>
        {showDetails ? (
          <Box sx={{marginTop: '16px'}}>
            <Typography variant="body2">{props.error}</Typography>
          </Box>
        ) : undefined}
      </Alert>
    </>
  );
};
